import React from "react";

const YZDunya: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto font-mono text-sm">
      <h1 className="text-2xl sm:text-3xl font-bold mb-6 sm:mb-8">Yapay Zeka ile Değişen Dünya</h1>

      {/* Canva Embed */}
      <div
        style={{
          position: "relative",
          width: "100%",
          height: 0,
          paddingTop: "56.25%", // 16:9 aspect ratio
          paddingBottom: 0,
          boxShadow: "0 2px 8px 0 rgba(63,69,81,0.16)",
          marginTop: "1.6em",
          marginBottom: "0.9em",
          overflow: "hidden",
          borderRadius: "8px",
          willChange: "transform",
        }}
      >
        <iframe
          loading="lazy"
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            border: "none",
            padding: 0,
            margin: 0,
          }}
          src="https://www.canva.com/design/DAGqw8SQILI/-yUm88dgoXS70mFpNvfguQ/view?embed"
          allow="fullscreen"
          allowFullScreen
        ></iframe>
      </div>

      <p>
        <a
          href="https://www.canva.com/design/DAGqw8SQILI/-yUm88dgoXS70mFpNvfguQ/view?utm_content=DAGqw8SQILI&utm_campaign=designshare&utm_medium=embeds&utm_source=link"
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:no-underline hover:text-black"
        >
          İlim Yayma - Yapay Zeka
        </a>{" "}- Ekrem Çetinkaya
      </p>
    </div>
  );
};

export default YZDunya; 